import DTextField from "components/common/DTextField";
import GridContainer from "components/common/GridContainer";
import GridItem from "components/common/GridItem";
import resource from "pages/EmployeeWorkspace/Resources/specialSkillResource";
/*import RHFSelect from "components/forms/RHFSelect";*/

export default function TabForm({ register, errors, control }) {
    return (
        <GridContainer spacing={2}>
            <GridItem xs={12} md={12}>
                <DTextField
                    name={resource.fields.description.name}
                    label={resource.fields.description.label}
                    required={resource.fields.description.required}
                    options={resource.fields.description.options ?? []}
                    multiline
                    error={!!errors.description}
                    {...register(resource.fields.description.name)}
                />
            </GridItem>
        </GridContainer>
    );
}
